import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RubroVendedorService } from 'src/app/services/rubro-vendedor.service';
import { RubroService } from 'src/app/services/rubro.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarVendedorComponent } from '../../shared/modal-seleccionar-vendedor/modal-seleccionar-vendedor.component';
import * as _ from 'lodash'
@Component({
  selector: 'app-vendedor-rubro',
  templateUrl: './vendedor-rubro.component.html',
  styleUrls: ['./vendedor-rubro.component.scss'],
  providers: [SecurityService]
})
export class VendedorRubroComponent implements OnInit {

  // Modales
  @ViewChild(ModalSeleccionarVendedorComponent, { static: true }) modalSeleccionarVendedor: ModalSeleccionarVendedorComponent

  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  listaRegistros: any = null
  loading: boolean = false
  vendedorSeleccionado: any = null

  optionsRubro: any[]
  rubrosVendedor: any[]

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private rutService: RutService,
    private toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private rubroService: RubroService,
    private rubroVendedorService: RubroVendedorService
  ) {
    this.log = this.clog.log('VENDEDOR-RUBRO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.loadRubros()
    this.createForms()
    this.formChangesSubscriptions()
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta

      this.optionsRubro = _.cloneDeep(registros)

      this.rubrosVendedor = registros.filter(p => p.activo)
      this.rubrosVendedor.forEach(rubro => {
        rubro.rubro_codigo = rubro.codigo
        rubro.rubro_nombre = rubro.descripcion
      })
    })
  }

  private createForms() {
    this.formHeader = this.fb.group({
      rutVendedor: [null]
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutVendedor").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutVendedor: string) => {
        this.modalSeleccionarVendedor.searchByRut(rutVendedor)
      })
  }

  /********* MODAL VENDEDOR *********/
  abrirModalSeleccionarVendedor() {
    this.modalSeleccionarVendedor.show()
  }

  onVendedorSeleccionado({ data }) {
    this.vendedorSeleccionado = data
    this.formHeader.get('rutVendedor').setValue(this.rutService.AgregarDV(this.vendedorSeleccionado.rut))
    this.obtenerRubrosPorVendedor(data.codigo)
  }

  onVendedorNoEncontrado() {
    this.vendedorSeleccionado = null
    this.rubrosVendedor = [...this.optionsRubro]
  }
  /********* MODAL VENDEDOR *********/

  obtenerRubrosPorVendedor(vendedor_codigo: number) {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        vendedor_codigo
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.rubroVendedorService.obtenerRubrosVendedor(inputParams, ({ respuesta, mensajes }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.rubrosVendedor = respuesta
    })
  }

  toogleAssigned(rubro) {
    this.log(rubro)
    rubro.asignado = !rubro.asignado
  }

  guardar() {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        vendedor_codigo: this.vendedorSeleccionado.codigo,
        listaRubroVendedor: this.rubrosVendedor.map(rubro => ({ rubro_codigo: rubro.rubro_codigo, asignado: rubro.asignado }))
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.rubroVendedorService.guardarListaRubro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.toastService.success('Operación exitosa')
    })
  }

}
